import React from 'react';
import Stack from "@mui/material/Stack";

function FormLayout({children, ...props}) {
  return (
    <Stack
      direction='column'
      // gap='18px'
      width='100%'
      borderRadius='9px'
      backgroundColor='white'
      padding='18px 27px 18px'
      justifyContent='flex-start'
      marginTop={{xs: '16px', sm: '10px'}}
      maxWidth={{xs: '464px', sm: '100%'}}
      boxShadow='0 4px 24px 0 rgba(0, 0, 0, 0.10)'
      className='FormLayout'
      style={{width: '100%'}}
      {...props}
    >
      {children}
    </Stack>
  );
}

export default FormLayout;